"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.initialize = exports.I18N_COOKIE_NAME = exports.i18n = exports.i18nextProvider = void 0;
var i18next_1 = __importDefault(require("i18next"));
var i18next_browser_languagedetector_1 = __importDefault(require("i18next-browser-languagedetector"));
var i18next_http_backend_1 = __importDefault(require("i18next-http-backend"));
var i18next_icu_1 = __importDefault(require("i18next-icu"));
var react_i18next_1 = require("react-i18next");
exports.i18nextProvider = react_i18next_1.I18nextProvider;
exports.i18n = i18next_1.default;
exports.I18N_COOKIE_NAME = 'sixfold_lng';
var initialize = function (options) {
    var logMissingKeys = options.logMissingKeys !== undefined ? options.logMissingKeys : true;
    var injectReactProvider = options.injectReactProvider !== undefined ? options.injectReactProvider : true;
    var defaultBrowserDetectionOptions = {
        lookupCookie: exports.I18N_COOKIE_NAME,
        order: ['querystring', 'cookie', 'htmlTag', 'navigator'],
        caches: ['localStorage', 'cookie'],
        cookieMinutes: 60 * 24 * 365, // 1 year
    };
    var instance = exports.i18n.use(new i18next_icu_1.default());
    if (options.useHttpBackend !== undefined) {
        instance = instance.use(i18next_http_backend_1.default);
    }
    if (options.detectBrowserLanguage !== undefined) {
        instance = instance.use(i18next_browser_languagedetector_1.default);
    }
    if (injectReactProvider) {
        instance = instance.use(react_i18next_1.initReactI18next);
    }
    instance
        .init(__assign(__assign(__assign({ resources: options.resources, fallbackLng: options.defaultLanguage || 'en', supportedLngs: options.supportedLanguages, nonExplicitSupportedLngs: options.nonExplicitSupportedLanguages, 
        // Handling missing keys
        saveMissing: logMissingKeys, missingKeyHandler: function (languages, namespace, key, fallbackValue) {
            if (logMissingKeys) {
                console.warn("Missing translation for key '".concat(key, "' in ").concat(languages[0], "/").concat(namespace, ", using fallback: '").concat(fallbackValue, "'"));
            }
            return fallbackValue;
        }, parseMissingKeyHandler: function (key) {
            return key;
        }, 
        /* otherwise we have nested JSON, which is more difficult to translate */
        keySeparator: false, interpolation: { escapeValue: false, prefix: '{', suffix: '}' } }, (injectReactProvider ? { react: { wait: true } } : {})), (typeof options.detectBrowserLanguage === 'object'
        ? { detection: __assign(__assign({}, defaultBrowserDetectionOptions), options.detectBrowserLanguage) }
        : { detection: defaultBrowserDetectionOptions })), (typeof options.useHttpBackend === 'object' ? { backend: options.useHttpBackend } : {})), undefined)
        .catch(console.error);
};
exports.initialize = initialize;
